import * as React from 'react';

import { Paper as PaperRaw, PaperProps, styled } from '@mui/material';

const PaperWrapper = styled(PaperRaw)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
}));

const Paper: React.FC<{ children?: React.JSX.Element | React.JSX.Element[] } & PaperProps> = (props: PaperProps) => {
  return <PaperWrapper {...props} className={props.className} />;
};

export default Paper;
